import OMT_BgLoadingUtil from '../../../Utils/OMT_BgLoadingUtil'; // eslint-disable-line import/no-cycle

export default class EventPostcardAssetManager {
  /**
   * Puts into queue the required assets for Friendship chest story mode
   */
  static loadAssets() {
    if (OMT.feature.getEventPostcardAssetStatus()) { return; }

    // Load the rest of the assets
    const postCardImages = G.OMTsettings.postcardEvent.cardData.postcardData.map((data) => data.image);
    OMT_BgLoadingUtil.getInstance().addBatchToQueue(
      postCardImages,
      (loadData) => {
        if (loadData.failed === 0) {
          OMT.feature.setEventPostcardAssetStatus(true);
          console.log('[ASSET] Event Postcard complete');
        }
      },
    );
  }
}
